// Aggregate benchmark results are only meaningful — and only safe to show
// without risking individual identification — once at least this many
// leaders are included.
export const MIN_LEADERS_REQUIRED = 10;
